import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isConsumer } from 'owa-session-store';

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * This capability is being used to check in which platforms the teams policies are enabled
 */
export const teamsPoliciesCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true; // This capability is enabled by default
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return isGlobalFeatureEnabled('fwk-teamsPolicies') && !isConsumer();
    },
};
